import MaintenancePage from './MaintenancePage';

function App() {
  return <MaintenancePage />;
}

export default App;
